// src/components/Header/Header.jsx
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import SearchBar from '../SearchBar/SearchBar';
import { companyInfo } from '../../constants/data';

const Header = () => {
  const [isNavCollapsed, setIsNavCollapsed] = useState(true);

  const handleNavCollapse = () => setIsNavCollapsed(!isNavCollapsed);

  return (
    <header className="sticky-top">
      <nav className="navbar navbar-expand-lg navbar-dark bg-dark">
        <div className="container-fluid">
          <Link className="navbar-brand d-flex align-items-center" to="/">
            <div className="me-2">
              <img 
                src="https://aaraventerpriseimages.blob.core.windows.net/website/aaravEnterpriseLogo.png" 
                alt="Aarav Enterprises Logo"
                className="img-fluid"
                style={{ 
                  height: '60px',
                  width: 'auto',
                  backgroundColor: 'white',
                  padding: '5px',
                  borderRadius: '5px'
                }}
              />
            </div>
            <div>
              <span className="fw-bold fs-4 text-white">{companyInfo.name}</span>
              <small className="d-block text-light fs-6">Forklift Services & Solutions</small>
            </div>
          </Link>
          
          <button
            className="navbar-toggler"
            type="button"
            onClick={handleNavCollapse}
            aria-controls="navbarNav"
            aria-expanded={!isNavCollapsed}
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          
          <div className={`${isNavCollapsed ? 'collapse' : ''} navbar-collapse`} id="navbarNav">
            <ul className="navbar-nav ms-auto">
              <li className="nav-item">
                <Link className="nav-link" to="/">Home</Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/about">Know Us</Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/services">Products & Services</Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/contact">Contact Us</Link>
              </li>
            </ul>
            <SearchBar />
            <Link to="/contact" className="btn btn-primary ms-lg-3 mt-2 mt-lg-0">
              <i className="bi bi-calendar-check me-2"></i>Book Service
            </Link>
          </div>
        </div>
      </nav>
    </header>
  );
};

export default Header;